import type { DOMProps } from "@react-types/shared";
import type { OverlayTriggerState } from "react-stately";
import { DialogComponent, Modal, VStack } from "widgets";

import type { FeatureLocation } from "../types.ts";
import style from "./search/SearchCard.module.css";

const ResultItem = ({
  item,
  handleSelect,
}: {
  item: FeatureLocation;
  handleSelect: (feature: FeatureLocation) => void;
}) => {
  return (
    <div className={style["search-result-item"]} onClick={() => handleSelect(item)}>
      <div className={style.title}>{item.contigSequenceId}</div>
      <div
        className={style.subtitle}
      >{`${item.range.start.toLocaleString("en-US")} - ${item.range.stop.toLocaleString("en-US")}`}</div>
    </div>
  );
};

export const LocationSelectionDialog = ({
  handleSelect,
  state,
  overlayProps,
  features,
}: {
  handleSelect: (feature: FeatureLocation) => void;
  state: OverlayTriggerState;
  overlayProps: DOMProps;
  features: FeatureLocation[];
}) => {
  return (
    <Modal state={state} {...overlayProps}>
      <DialogComponent
        data-testid="location-selection-dialog"
        title="Multiple Locations Found"
        subtitle="We found several possible matches. Please select one from the list below."
        width={500}
        asPanelHeader
      >
        <VStack style={{ maxHeight: "60vh" }}>
          {features.map((item) => (
            <ResultItem key={item.id} item={item} handleSelect={handleSelect} />
          ))}
        </VStack>
      </DialogComponent>
    </Modal>
  );
};
